(ns rothko.editor.document.script.spec
  (:require [clojure.spec.alpha :as s]
            [clojure.spec.gen.alpha :as gen]
            [clojure.string :as str]))

(def implementation->spec
  {:est-transcription-annotator ::transcript
   :est-error-annotator ::transcript
   :script-annotator ::script
   :mwe-annotator ::mwe-script})

;;; Common

(s/def ::word string?)

(s/def ::system? #{true})

(s/def ::edited? #{true})

(s/def ::tagged? #{true})

(s/def :tag/name keyword?)

(s/def :mark/name keyword?)

(s/def ::marks
  (s/coll-of
   (s/keys
    :req-un [:mark/name]
    :opt-un [::system?])
   :kind set?))

;;; Speech transcript

(s/def :transcript-token/type #{:word :space :edit :tag})

(s/def ::transcription-number
  (s/or
   :s string?
   :d (s/double-in :min 0 :NaN? false :infinite? false)
   :i int?))

(s/def :transcript-token/start ::transcription-number)

(s/def :transcript-token/duration ::transcription-number)

(s/def :transcript-token/confidence ::transcription-number)

(s/def ::transcript
  (s/coll-of
   (s/keys
    :req-un [::word
             :transcript-token/type]
    :opt-un [:transcript-token/start
             :transcript-token/duration
             :transcript-token/confidence
             ::system?
             ::edited?
             ::tagged?
             :tag/name
             ::marks])))

;;; Text script

(def unicode-whitespace #?(:clj #"[\p{javaWhitespace}\u00A0\u2007\u202F]*"))

(defn blank?
  [s]
  #?(:clj  (or (str/blank? s)
               (boolean (re-matches unicode-whitespace s)))
     :cljs (str/blank? s)))

(defn doesnt-contain-space? [s] (not (str/includes? s " ")))

(defn doesnt-contain-newline? [s] (not (str/includes? s "\n")))

(defn spaces-newlines-generator
  []
  (->> [" " "\n"]
       gen/elements
       gen/vector
       (gen/fmap str/join)
       (gen/such-that (complement #{""}))))

(s/def :script-token/score
  (s/or :nil nil?
        :number (s/with-gen number? gen/int)))

(s/def :script-token.space/type #{:space :space-edit})

(s/def :script-token.non-space/type #{:word :edit :tag})

(s/def :script-token.space/word
  (s/with-gen
   (s/and ::word
          seq
          blank?)
   spaces-newlines-generator))

(s/def :script-token.non-space/word
  (s/and ::word
         seq
         doesnt-contain-space?
         doesnt-contain-newline?))

(s/def ::script-token.common
  (s/keys :opt-un [:script-token/score
                   ::system?
                   ::edited?
                   ::tagged?
                   :tag/name]))

(s/def ::script-token.space
  (s/merge
   (s/keys :req-un [:script-token.space/type
                    :script-token.space/word])
   ::script-token.common))

(s/def ::script-token.non-space
  (s/merge
   (s/keys :req-un [:script-token.non-space/type
                    :script-token.non-space/word])
   ::script-token.common))

(s/def ::script-token
  (s/or :space ::script-token.space
        :non-space ::script-token.non-space))

(s/def ::script (s/coll-of ::script-token))

;;; Multi-Word Expression script

(s/def :mwe-token/type #{:word :space :tag})

(defn all-discontinuities-inside-mwe?
  [script]
  (some?
   (reduce
    (fn [mwe-level token]
      (let [discontinuity (->> token :marks (map :name) set :discontinuity)]
        (cond
          (= (:name token) :mwe-start) (inc mwe-level)
          (= (:name token) :mwe-end) (dec mwe-level)
          (and discontinuity (not (pos? mwe-level))) (reduced nil)
          :else mwe-level)))
    0
    script)))

(s/def ::mwe-script
  (s/and
   (s/coll-of
    (s/keys
     :req-un [::word
              :mwe-token/type]
     :opt-un [:tag/name
              ::marks]))
   all-discontinuities-inside-mwe?))
